<template>
    <v-app>
        <loading :loading="!appLoadedOnce || loading"></loading>
        
        <template v-if="appLoadedOnce">
            <app-menu v-model="openMenu"/>

            <navbar :height="navbarHeight" @menu="openMenu = !openMenu"/>
            

            <!-- confirm email msg -->
            <div v-if="innerApp && !confirmed" class="fixed-top-bar d-flex align-center justify-space-between justify-md-center pa-0 white--text orange" :style="`top: ${navbarHeight}px`">
                <div class="px-3">لم يتم تأكيد البريد الإلكتروني</div>
                <v-btn text large tile color="grey darken-3" class="light--text" @click.stop="openConfirmPage">
                    <span class="white--text">تأكيد</span>
                </v-btn>
            </div>
            
            <!-- full screen overlay - app is in maintainance -->
            <app-down :show="appIsDown" /> 

            <v-main v-if="appLoadedOnce && !appIsDown" class="main-container" :class="{'pc': pcOnly, 'white': $route.meta.whiteBackground}" :style="'padding-top: ' + navbarHeight">
                <transition :name="transitionName" mode="out-in">
                    <router-view>
                    </router-view>
                </transition> 
            </v-main>

            <app-msg :navbar-height="navbarHeight" />
        </template>

    </v-app>
</template>

<script>
import AppDown from "./components/default/dialogs/app-down";
import AppMsg from "./components/default/app-msg";
import Loading from "./components/default/loading";

import GlobalComputed from './helpers/global-computed'
import GlobalMethods from './helpers/global-methods'

import Navbar from './components/main/navbar/navbar'
import AppMenu from './components/main/app-menu'

import Echo from "laravel-echo"
 
export default {
    name: "App",
    
    components: {
        AppDown,
        Loading,
        AppMsg,
        Navbar,
        AppMenu
    },

    data: () => ({
        openMenu: false,
        navbarHeight: 65,
        transitionName: 'fade-up',
    }),
    computed: {
        appIsDown(){
            return this.appData && this.appData.appIsDown;
        },
        showFooter(){
            return this.$route.meta.footer;
        },
        innerApp(){
            return this.isAuthed && this.$route.name !== 'confirm';
        },
        confirmed(){
            if (!this.user || !this.appData.email_verification){
                return true;
            }
            return !!this.user.email_verified_at;
        },
        loading(){
            return this.$store.state.globalModule.loading;
        },
        ...GlobalComputed
    },
    watch: {
        $route(to, from){
            // force email verification
            this.forceEmailConfirm(to.name);
            this.transitionName = 'fade-up';
            
            if (to.meta.footer){
                // to fix footer bug with transition
                this.transitionName = 'fade';
            }
        },
        isAuthed(authed){
            if (!authed){
                this.$router.push({name: 'login'});
            }
        },
    },
    methods: {
        openConfirmPage(){
            this.$router.push({name: 'confirm'});
        },
        forceEmailConfirm(route=null){
            if (!route){
                route = this.$route.name;
            }
            const force = process.env.VUE_APP_FORCE_CONFIRMATION;
            if (force){
                if (!this.confirmed){
                    if (route !== 'confirm'){
                        this.openConfirmPage();
                    }
                }
            }
        },
        afterAuthActions(){
            this.forceEmailConfirm();
            this.initWebsockets();
        },
        initWebsockets(){
            if (this.appData.WsConfig){
                window.Pusher = require('pusher-js')
                let WsConfig = this.appData.WsConfig;
                // change auth endpoint
                const token = window.localStorage.getItem('tK');
                WsConfig.authEndpoint = `${WsConfig.authEndpoint}?api_token=${token}`
                
                window.Echo = new Echo(WsConfig);

            }
        },
        initApp(){
            const self = this;
            // window.console.log('App Init');
            // check token is valid or not
            this.$store.dispatch('checkAuth').then(response=>{
                // then set loaded to true
                window.setTimeout(()=>{
                    self.$store.dispatch('appLoaded'); // set app loaded status
                }, 250);

                if (response.authed){
                    self.afterAuthActions();
                }
                if (response.redirect){
                    self.$router.push({name: response.redirect});
                }
            }).catch(error=>{
                this.checkErrorStatus(error);
                this.showMsg('(2) تعذر التحقق من بياناتك، أعد فتح التطبيق');
                // this.snackMsg = {show: true, text: "حدثت مشكلة أثناء تحميل بياناتك"};
            });

        },

        checkErrorStatus(error){
            if (error && error.response && error.response.status){
                // if unauthorized (maybe logout or token changed)
                if (error.response.status === 401){
                    this.logout();
                }
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        
        // first load app global data / settings (admin app data)
        this.$store.dispatch('loadAppData').then(()=>{
                
            // if nor running, init app now
            // we are on browser/web app!
            this.initApp();
            
        }).catch(()=>{
            this.showMsg('(1) تعذر تحميل بيانات التطبيق، أعد فتح التطبيق');
        })
    }
};
</script>

<style lang="scss">
@import 'scss/main';
.main-container{
    background-color: #fafafa;
}
</style>